import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_NOT_FOUND',
    statusCode: 404,
    message: {
        en: 'Not Found',
    },
} as CustomErrorType;